<app-product-hero
  [level]="productLevels.SmartTag"
  title="How to help reunite missing pets"
  subtitle="Using the contact information below, please contact the keeper. Or alternatively, call identi (the pet's microchip provider) on 0330 912 8001."
  [buyHidden]="true"
  [compareVisible]="false"
  [levelsVisible]="false"
></app-product-hero>

<div class="container mt-4">
  <div class="row mb-3">
    <div class="col-12">
      <div class="back-to-qr-preferences">
        <a [routerLink]="['/smart-tag-for-pet', petId, 'qr-code-preferences']">
          <fa-icon [icon]="['fas', 'angle-left']"></fa-icon>Back to QR Code
          Preferences
        </a>
      </div>

      <h4>Pet information</h4>
    </div>
    <div *ngIf="!keeperDataProvided && !petDataProvided" class="row mb-5">
      <h5>No data provided about the pet or the keeper</h5>
    </div>

    <div *ngIf="keeperDataProvided || petDataProvided" class="row mb-5">
      <div class="col-md-6">
        <ul class="list-group bio-left">
          <li *ngIf="!keeperDataProvided" class="list-group-item">
            <h5 class="text-primary">Keeper details</h5>
            Not provided
          </li>
          <li *ngIf="qrCodeData.petImageId" class="list-group-item">
            <h5 class="text-primary">Image</h5>
            <div class="pet-image-wrapper">
              <div
                class="pet-image"
                [ngStyle]="
                  petImage && { 'background-image': 'url(' + petImage + ')' }
                "
              ></div>
            </div>
          </li>
          <li *ngIf="qrCodeData.keeperName" class="list-group-item">
            <h5 class="text-primary">Keeper name</h5>
            {{ qrCodeData.keeperName }}
          </li>
          <li *ngIf="qrCodeData.keeperEmail" class="list-group-item">
            <h5 class="text-primary">Keeper Email</h5>
            {{ qrCodeData.keeperEmail }}
          </li>
          <li *ngIf="qrCodeData.keeperPhone" class="list-group-item">
            <h5 class="text-primary">Keeper Phone number</h5>
            {{ qrCodeData.keeperPhone }}
          </li>
          <li *ngIf="qrCodeData.keeperAddress" class="list-group-item">
            <h5 class="text-primary">Keeper Address</h5>
            {{ qrCodeData.keeperAddress }}
          </li>
        </ul>
      </div>
      <div class="col-md-6">
        <ul class="list-group bio-right">
          <li *ngIf="!petDataProvided" class="list-group-item">
            <h5 class="text-primary">Pet details</h5>
            Not provided
          </li>
          <li *ngIf="qrCodeData.petName" class="list-group-item">
            <h5 class="text-primary">Pet name</h5>
            {{ qrCodeData.petName }}
          </li>
          <li *ngIf="qrCodeData.petSpecies" class="list-group-item">
            <h5 class="text-primary">Pet type</h5>
            {{ qrCodeData.petSpecies }}
          </li>
          <li *ngIf="qrCodeData.petBreed" class="list-group-item">
            <h5 class="text-primary">Breed</h5>
            {{ qrCodeData.petBreed }}
          </li>
          <li *ngIf="qrCodeData.petBirthDate" class="list-group-item">
            <h5 class="text-primary">Birth month/year</h5>
            {{ qrCodeData.petBirthDate | date : "MM/y" }}
          </li>
          <li *ngIf="qrCodeData.petGender" class="list-group-item">
            <h5 class="text-primary">Sex</h5>
            <span>{{ qrCodeData.petGender }}</span>
          </li>
          <li *ngIf="qrCodeData.petNeutered" class="list-group-item">
            <h5 class="text-primary">Neutered/spayed</h5>
            <span>{{ qrCodeData.petNeutered }}</span>
          </li>
          <li *ngIf="qrCodeData.petExistingConditions" class="list-group-item">
            <h5 class="text-primary">Existing conditions</h5>
            {{ qrCodeData.petExistingConditions }}
          </li>
        </ul>
      </div>
      <div class="col-12 mt-4">
        <h4>Next steps:</h4>
        <div class="col-md-6">
          <ul class="list-group bio-right">
            <li>
              Please contact the pet keeper using the details provided above.
            </li>
            <li>
              If you have not shared your location and are unable to get in
              touch with the keeper, please call identi on
              <a href="tel:03309128077"> 0330 912 8077</a>.
            </li>
            <li>
              If you have shared your location, we kindly ask that you please
              wait with the pet and reunite with the keeper.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
